import React from 'react';
import ReactDOM from 'react-dom';
import * as firebase from "firebase";

import App from './App';
import './index.css';
import { Router, Route, IndexRoute, hashHistory } from 'react-router'
import { Provider } from 'react-redux'
import store from './store.js'
import Layout from './components/Layout.jsx'
import Home from './components/pages/Home.jsx'
import License from './components/pages/License.jsx'
import Image from './components/pages/Image.jsx'
import Video from './components/pages/Video.jsx'
import Login from './components/pages/Login.jsx'
import Chat from './components/pages/Chat.jsx'
import ConvoList from './components/pages/ConvosList.jsx'




var config = {
    apiKey: "AIzaSyAlBOIUw4Rv5QlReu68dQJV7AOTRt4dmik",
    authDomain: "androidmessenger-c30a7.firebaseapp.com",
    databaseURL: "https://androidmessenger-c30a7.firebaseio.com",
    projectId: "androidmessenger-c30a7",
    storageBucket: "androidmessenger-c30a7.appspot.com",
    messagingSenderId: "1081342143268"
};
firebase.initializeApp(config);

ReactDOM.render(

    <Provider store={store}>
    <Router history={hashHistory}>
        <Route path="/" component={Layout}>
            <IndexRoute component={Login}></IndexRoute>
            <Route path="/license" component={License}></Route>
            <Route path="/login" component={Login}></Route>
            <Route path="/image/:id" component={Image}></Route>
            <Route path="/video/:id" component={Video}></Route>
            <Route path="/chat/" component={Chat}></Route>
            <Route path="/convoList/" component={ConvoList}></Route>

        </Route>
    </Router>
    </Provider>,
    document.getElementById('app')
);




// WEBPACK FOOTER //
// ./src/index.js